import React from 'react';

// Buton tipleri:
// callback: { text, callback }
// url: { text, url }
// web_app: { text, web_app: { url } }

const BTN_TYPES = [
  { value: 'callback', label: '⚡ Callback', color: '#3b82f6', desc: 'Bot içi aksiyon' },
  { value: 'url', label: '🔗 URL Link', color: '#10b981', desc: 'Dış site linki' },
  { value: 'web_app', label: '📱 Mini App', color: '#8b5cf6', desc: 'Telegram Mini App' },
];

function getBtnType(btn) {
  if (btn.web_app) return 'web_app';
  if (btn.url) return 'url';
  return 'callback';
}

function ButtonItem({ btn, rowIdx, btnIdx, onUpdate, onDelete, onMove, totalInRow }) {
  const type = getBtnType(btn);
  const typeInfo = BTN_TYPES.find(t => t.value === type) || BTN_TYPES[0];

  function handleTypeChange(newType) {
    const clean = { text: btn.text || 'Buton' };
    if (newType === 'callback') clean.callback = '';
    if (newType === 'url') clean.url = 'https://';
    if (newType === 'web_app') clean.web_app = { url: 'https://' };
    onUpdate(rowIdx, btnIdx, '__replace__', clean);
  }

  return (
    <div style={{
      background: `${typeInfo.color}10`,
      border: `1.5px solid ${typeInfo.color}50`,
      borderRadius: 10,
      padding: '10px 12px',
    }}>
      {/* Tip seçici */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 8, flexWrap: 'wrap' }}>
        {BTN_TYPES.map(t => (
          <button key={t.value} onClick={() => handleTypeChange(t.value)} style={{
            fontSize: 10, padding: '3px 9px', borderRadius: 6, cursor: 'pointer',
            border: `1px solid ${t.color}${type === t.value ? 'cc' : '44'}`,
            background: type === t.value ? `${t.color}25` : 'transparent',
            color: type === t.value ? t.color : 'var(--text3)',
            fontWeight: type === t.value ? 700 : 400,
            transition: 'all 0.15s',
          }}>{t.label}</button>
        ))}
      </div>

      {/* Buton metni */}
      <div style={{ marginBottom: 6 }}>
        <label style={{ fontSize: 10, color: 'var(--text3)', display: 'block', marginBottom: 3 }}>BUTON METNİ</label>
        <input
          className="input"
          value={btn.text || ''}
          onChange={e => onUpdate(rowIdx, btnIdx, 'text', e.target.value)}
          placeholder="Buton metni yazın..."
          style={{ fontSize: 13, padding: '5px 9px', width: '100%' }}
        />
      </div>

      {/* Tipe göre değer alanı */}
      {type === 'callback' && (
        <div>
          <label style={{ fontSize: 10, color: '#60a5fa', display: 'block', marginBottom: 3 }}>⚡ CALLBACK DEĞERİ</label>
          <input
            className="input"
            value={btn.callback || ''}
            onChange={e => onUpdate(rowIdx, btnIdx, 'callback', e.target.value)}
            placeholder="Örn: ana_menu, satin_al, evet"
            style={{ fontSize: 12, padding: '4px 9px', width: '100%' }}
          />
          <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 3 }}>
            Bu değer flow'da edge koşulunda kullanılır
          </div>
        </div>
      )}

      {type === 'url' && (
        <div>
          <label style={{ fontSize: 10, color: '#34d399', display: 'block', marginBottom: 3 }}>🔗 HEDEF URL</label>
          <input
            className="input"
            value={btn.url || ''}
            onChange={e => onUpdate(rowIdx, btnIdx, 'url', e.target.value)}
            placeholder="https://www.example.com"
            style={{ fontSize: 12, padding: '4px 9px', width: '100%' }}
          />
          <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 3 }}>
            Kullanıcı butona basınca bu URL açılır. https:// ile başlamalı.
          </div>
        </div>
      )}

      {type === 'web_app' && (
        <div>
          <label style={{ fontSize: 10, color: '#a78bfa', display: 'block', marginBottom: 3 }}>📱 MINI APP URL</label>
          <input
            className="input"
            value={btn.web_app?.url || ''}
            onChange={e => onUpdate(rowIdx, btnIdx, 'web_app', { url: e.target.value })}
            placeholder="https://your-mini-app.com"
            style={{ fontSize: 12, padding: '4px 9px', width: '100%' }}
          />
          <div style={{ fontSize: 10, color: '#a78bfa', marginTop: 3 }}>
            📱 Telegram Mini App. Mutlaka HTTPS olmalı. WebApp JS API kullanabilir.
          </div>
        </div>
      )}

      {/* Alt butonlar */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
        <div style={{ display: 'flex', gap: 2 }}>
          <button onClick={() => onMove(rowIdx, btnIdx, 'left')} disabled={btnIdx === 0}
            title="Sola taşı"
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: btnIdx===0?'var(--text3)':'var(--text)', cursor: btnIdx===0?'default':'pointer', fontSize: 12, padding: '3px 8px', borderRadius: 5 }}>←</button>
          <button onClick={() => onMove(rowIdx, btnIdx, 'right')}
            title="Sağa taşı"
            style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'var(--text)', cursor: 'pointer', fontSize: 12, padding: '3px 8px', borderRadius: 5 }}>→</button>
        </div>
        <button onClick={() => onDelete(rowIdx, btnIdx)}
          style={{ background: 'rgba(239,68,68,0.12)', border: '1px solid rgba(239,68,68,0.3)', color: '#f87171', cursor: 'pointer', fontSize: 11, padding: '3px 10px', borderRadius: 5 }}>
          ✕ Sil
        </button>
      </div>
    </div>
  );
}

export default function InlineButtonBuilder({ value, onChange }) {
  const rows = Array.isArray(value) && value.length > 0
    ? (Array.isArray(value[0]) ? value : [value])
    : [];

  function update(fn) {
    const newRows = fn(JSON.parse(JSON.stringify(rows)));
    onChange(newRows);
  }

  function makeBtn(type) {
    if (type === 'url') return { text: 'Siteye Git', url: 'https://' };
    if (type === 'web_app') return { text: 'Mini App Aç', web_app: { url: 'https://' } };
    return { text: 'Yeni Buton', callback: '' };
  }

  function addRow(type = 'callback') {
    update(r => [...r, [makeBtn(type)]]);
  }

  function addBtnToRow(rowIdx, type = 'callback') {
    update(r => { r[rowIdx] = [...r[rowIdx], makeBtn(type)]; return r; });
  }

  function deleteRow(rowIdx) {
    update(r => r.filter((_, i) => i !== rowIdx));
  }

  function updateBtn(rowIdx, btnIdx, key, val) {
    update(r => {
      if (key === '__replace__') {
        r[rowIdx][btnIdx] = val;
      } else {
        r[rowIdx][btnIdx] = { ...r[rowIdx][btnIdx], [key]: val };
        // Tip alanlarını temizle
        if (key === 'url') { delete r[rowIdx][btnIdx].callback; delete r[rowIdx][btnIdx].web_app; }
        if (key === 'web_app') { delete r[rowIdx][btnIdx].url; delete r[rowIdx][btnIdx].callback; }
        if (key === 'callback') { delete r[rowIdx][btnIdx].url; delete r[rowIdx][btnIdx].web_app; }
      }
      return r;
    });
  }

  function deleteBtn(rowIdx, btnIdx) {
    update(r => {
      r[rowIdx] = r[rowIdx].filter((_, i) => i !== btnIdx);
      if (r[rowIdx].length === 0) r = r.filter((_, i) => i !== rowIdx);
      return r;
    });
  }

  function moveBtn(rowIdx, btnIdx, dir) {
    update(r => {
      const row = [...r[rowIdx]];
      if (dir === 'left' && btnIdx > 0) {
        [row[btnIdx - 1], row[btnIdx]] = [row[btnIdx], row[btnIdx - 1]];
      } else if (dir === 'right') {
        if (btnIdx < row.length - 1) {
          [row[btnIdx], row[btnIdx + 1]] = [row[btnIdx + 1], row[btnIdx]];
        } else if (rowIdx < r.length - 1) {
          const btn = row.splice(btnIdx, 1)[0];
          r[rowIdx] = row;
          r[rowIdx + 1] = [btn, ...r[rowIdx + 1]];
          return r;
        }
      }
      r[rowIdx] = row;
      return r;
    });
  }

  function moveRowUp(rowIdx) {
    if (rowIdx === 0) return;
    update(r => { [r[rowIdx - 1], r[rowIdx]] = [r[rowIdx], r[rowIdx - 1]]; return r; });
  }

  function moveRowDown(rowIdx) {
    update(r => {
      if (rowIdx >= r.length - 1) return r;
      [r[rowIdx], r[rowIdx + 1]] = [r[rowIdx + 1], r[rowIdx]];
      return r;
    });
  }

  const totalBtns = rows.reduce((s, r) => s + r.length, 0);

  return (
    <div>
      {/* Başlık */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <span style={{ fontSize: 11, color: '#6899cc', fontWeight: 600 }}>INLINE BUTONLAR</span>
        <span style={{ fontSize: 10, color: 'var(--text3)' }}>{totalBtns} buton · {rows.length} satır</span>
      </div>

      {/* Tip rehberi */}
      <div style={{ display: 'flex', gap: 5, marginBottom: 12, flexWrap: 'wrap' }}>
        {BTN_TYPES.map(t => (
          <div key={t.value} style={{ fontSize: 10, padding: '2px 8px', borderRadius: 6, background: `${t.color}15`, color: t.color, border: `1px solid ${t.color}35` }}>
            {t.label} — {t.desc}
          </div>
        ))}
      </div>

      {/* Satırlar */}
      {rows.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '20px 16px', background: 'rgba(255,255,255,0.03)', borderRadius: 8, border: '1px dashed rgba(255,255,255,0.12)', color: 'var(--text3)', fontSize: 13, marginBottom: 10 }}>
          Henüz buton yok. Aşağıdan ekle.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 10 }}>
          {rows.map((row, rowIdx) => (
            <div key={rowIdx} style={{ background: 'rgba(255,255,255,0.03)', borderRadius: 10, border: '1px solid rgba(255,255,255,0.08)', padding: '10px 12px' }}>
              {/* Satır başlık */}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ fontSize: 11, color: 'var(--text3)', fontWeight: 600 }}>
                  Satır {rowIdx + 1} — {row.length} buton
                </span>
                <div style={{ display: 'flex', gap: 3 }}>
                  <button onClick={() => moveRowUp(rowIdx)} disabled={rowIdx === 0} className="btn btn-ghost btn-sm" style={{ padding: '2px 7px', fontSize: 11 }}>↑</button>
                  <button onClick={() => moveRowDown(rowIdx)} disabled={rowIdx === rows.length - 1} className="btn btn-ghost btn-sm" style={{ padding: '2px 7px', fontSize: 11 }}>↓</button>
                  <button onClick={() => addBtnToRow(rowIdx, 'callback')} className="btn btn-ghost btn-sm" style={{ padding: '2px 7px', fontSize: 10, color: '#60a5fa' }}>+CB</button>
                  <button onClick={() => addBtnToRow(rowIdx, 'url')} className="btn btn-ghost btn-sm" style={{ padding: '2px 7px', fontSize: 10, color: '#34d399' }}>+URL</button>
                  <button onClick={() => addBtnToRow(rowIdx, 'web_app')} className="btn btn-ghost btn-sm" style={{ padding: '2px 7px', fontSize: 10, color: '#a78bfa' }}>+App</button>
                  <button onClick={() => deleteRow(rowIdx)} className="btn btn-danger btn-sm" style={{ padding: '2px 7px', fontSize: 10 }}>Sil</button>
                </div>
              </div>

              {/* Butonlar */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {row.map((btn, btnIdx) => (
                  <ButtonItem
                    key={btnIdx}
                    btn={btn} rowIdx={rowIdx} btnIdx={btnIdx}
                    totalInRow={row.length}
                    onUpdate={updateBtn} onDelete={deleteBtn} onMove={moveBtn}
                  />
                ))}
              </div>

              {/* Önizleme */}
              <div style={{ marginTop: 10, padding: '8px 10px', background: 'rgba(0,0,0,0.2)', borderRadius: 8, border: '1px solid rgba(255,255,255,0.06)' }}>
                <div style={{ fontSize: 10, color: 'var(--text3)', marginBottom: 5 }}>📱 Telegram önizleme:</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {row.map((btn, i) => {
                    const t = getBtnType(btn);
                    const tInfo = BTN_TYPES.find(x => x.value === t) || BTN_TYPES[0];
                    return (
                      <div key={i} style={{
                        fontSize: 12, padding: '5px 14px', borderRadius: 6,
                        background: `${tInfo.color}20`, border: `1px solid ${tInfo.color}50`,
                        color: tInfo.color, display: 'flex', alignItems: 'center', gap: 4,
                      }}>
                        {t === 'web_app' ? '📱' : t === 'url' ? '🔗' : '⚡'}
                        {btn.text || 'Buton'}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Yeni satır ekle */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 6 }}>
        <button onClick={() => addRow('callback')} className="btn btn-ghost btn-sm"
          style={{ justifyContent: 'center', borderStyle: 'dashed', borderColor: '#3b82f655', color: '#60a5fa', fontSize: 12, padding: '7px' }}>
          + Callback
        </button>
        <button onClick={() => addRow('url')} className="btn btn-ghost btn-sm"
          style={{ justifyContent: 'center', borderStyle: 'dashed', borderColor: '#10b98155', color: '#34d399', fontSize: 12, padding: '7px' }}>
          + URL Link
        </button>
        <button onClick={() => addRow('web_app')} className="btn btn-ghost btn-sm"
          style={{ justifyContent: 'center', borderStyle: 'dashed', borderColor: '#8b5cf655', color: '#a78bfa', fontSize: 12, padding: '7px' }}>
          + Mini App
        </button>
      </div>

      {rows.length > 0 && (
        <div style={{ fontSize: 10, color: 'var(--text3)', marginTop: 8, lineHeight: 1.7, background: 'rgba(255,255,255,0.03)', padding: '6px 10px', borderRadius: 6 }}>
          💡 Aynı satırdaki butonlar yan yana görünür · Farklı satırlar alt alta gelir<br/>
          🔗 URL: Dış siteye yönlendirir · 📱 Mini App: Telegram WebApp açar
        </div>
      )}
    </div>
  );
}
